export default "__VITE_ASSET__SvfYh8p8__"